namespace $ {

	export type $shm_hitalama_resilience_area =
		| 'application'
		| 'navigation'
		| 'team'
		| 'map'
		| 'widget'
		| 'local_cache'

	const reported = new Set< string >

	export function $shm_hitalama_resilience_error_message( area: $shm_hitalama_resilience_area ) {
		switch( area ) {
			case 'team': return 'Данные команды временно недоступны. Доступ к проектам закрыт до восстановления данных.'
			case 'map': return 'Карта временно недоступна. Остальные разделы продолжают работать.'
			case 'widget': return 'Часть интерфейса временно недоступна. Остальные виджеты продолжают работать.'
			case 'local_cache': return 'Обнаружена повреждённая часть локальной копии. Она удалена из кэша и будет получена заново при синхронизации.'
			case 'navigation': return 'Не удалось открыть выбранный раздел. Остальная часть приложения продолжает работать.'
			default: return 'Часть приложения временно недоступна.'
		}
	}

	export function $shm_hitalama_resilience_signature(
		area: $shm_hitalama_resilience_area,
		error: unknown,
		context = '',
	) {
		const name = error instanceof Error ? error.name : typeof error
		const message = error instanceof Error ? error.message : String( error )
		return `${ area }:${ context }:${ name }:${ message }`
	}

	export function $shm_hitalama_resilience_id( source: string ) {
		let hash = 2166136261
		for( let index = 0; index < source.length; ++index ) {
			hash ^= source.charCodeAt( index )
			hash = Math.imul( hash, 16777619 )
		}
		return ( hash >>> 0 ).toString( 36 )
	}

	export function $shm_hitalama_resilience_report(
		area: $shm_hitalama_resilience_area,
		error: unknown,
		context = '',
	) {
		if( $mol_promise_like( error ) ) throw error

		const signature = $shm_hitalama_resilience_signature( area, error, context )
		if( reported.has( signature ) ) return signature
		reported.add( signature )
		if( reported.size > 200 ) reported.delete( reported.values().next().value! )

		const normalized = error instanceof Error ? error : new Error( String( error ) )
		const details = `${ normalized.name }: ${ normalized.message }`
		const copy_text = [
			`[Hitalama:${ area }]${ context ? ` ${ context }` : '' }`,
			normalized.stack || details,
		].join( '\n' )
		console.error( `[Hitalama:${ area }]${ context ? ` ${ context }` : '' }`, normalized )
		$shm_hitalama_telemetry_sentry.capture( normalized, area, { context } )
		;( $.$shm_hitalama_notifications as any ).show({
			id: `hitalama_resilience_${ $shm_hitalama_resilience_id( signature ) }`,
			type: area === 'local_cache' ? 'warning' : 'error',
			title: area === 'local_cache' ? 'Восстановление локальных данных' : 'Ошибка отображения',
			message: $shm_hitalama_resilience_error_message( area ),
			details,
			copy_text,
			timeout: area === 'local_cache' ? 10_000 : 0,
		})
		return signature
	}

	export function $shm_hitalama_resilience_read< Value >(
		area: $shm_hitalama_resilience_area,
		context: string,
		task: ()=> Value,
		fallback: Value,
	) {
		return $mol_error_fence(
			task,
			error => {
				$shm_hitalama_resilience_report( area, error, context )
				return fallback
			},
			promise => {
				$shm_hitalama_telemetry_sentry.promise_watch( promise, `${ area }:${ context }` )
				return fallback
			},
		)
	}

	export function $shm_hitalama_resilience_reset_for_test() {
		reported.clear()
	}

}
